import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[sgpComponent]'
})
export class SgpComponentDirective {
	constructor(public viewContainerRef: ViewContainerRef) {}
}
